// src/theme/palettes/lightPalette.js
const lightPalette = {
  mode: "light",
  contrastThreshold: 4.5, // Higher contrast for better readability
  primary: {
    main: "rgb(14, 125, 156)", //  color of nav bar
  },
  secondary: {
    main: "#0f766e",
  },
  error: {
    main: "#ef4444",
  },
  warning: {
    main: "#d97706",
  },
  info: {
    main: "#10b981",
  },
  success: {
    main: "#10b981",
  },
  background: {
    default: "#ffffff",
    paper: "#f3f4f5",
    papersecondary: "rgb(249, 250, 251)", // Paper associated with user
  },
  // Improved text contrast for readability on mobile
  text: {
    primary: "rgba(0, 0, 0, 0.87)", // Slightly darker for better readability
    white: " rgb(255, 255, 255)",
  },
};

export default lightPalette;
